module.exports = __webpack_public_path__ + "img/leftthigh-ectomorph-male.e428f279.svg";